import Phone from '@letsdial/phone'
import { App } from 'vue'
export default {
  install: (app: App) => {
    if (import.meta.env.VITE_PHONE_URL) {
      const phone = new Phone(import.meta.env.VITE_PHONE_URL)
      // if (authStore.extensionPassword && authStore.user) {
      //   phone.connect(`${authStore.user.id + 10000}`, authStore.extensionPassword)
      // }
      // const socket = new LetsDialSocketClient(
      //   options?.letsDialServerUrl ?? '',
      //   options?.apiToken,
      // )
      app.config.globalProperties.$phone = phone

      app.provide('phone', phone)
    } else {
      throw Error('NO Phone URL')
    }
  },
}
